import { useLayoutEffect, useState, useSyncExternalStore } from "react";
import { useLocation } from "wouter";
import PrivacyControls from "./PrivacyControls";
import { MarketingConsent } from "@/lib/privacyConsent";

export default function MarketingPrivacy() {
  const [consent] = useState(() => new MarketingConsent());
  const snapshot = useSyncExternalStore(consent.subscribe, consent.getSnapshot);
  const [location] = useLocation();
  useLayoutEffect(() => consent.start(), [consent]);
  useLayoutEffect(() => { consent.routeChanged(); }, [consent, location]);
  const authPage = /^\/sign-(in|up)(?:\/|$)/.test(location);
  return <PrivacyControls {...snapshot} onSave={consent.save} inlineBanner={authPage} />;
}
